import React, { useEffect, useMemo, useState } from "react";
import { Box, Text, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Select, Menu, MenuButton, MenuList, MenuItem, Button, Tag } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ExpenseTable from "./expenseTable";
import { poNumberFormate,currencyFormate } from "jsFunctions/helperFunctions";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { expenseDataColumns, salesDataColumns, salesGstRecordColumns, salesPaymentRecordColumns, salesTdsRecordColumns } from "./variable/variable";
import { FaEllipsisV } from "react-icons/fa";
import { useToasts } from "react-toast-notifications";
import * as FileSaver from 'file-saver';
import XLXS from 'sheetjs-style';
import { getVendorExpenseExcelData } from "components/exportData/excelData/vendorExpenseExcelData";
import moment from "moment";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { fetchAsyncGetClientExpenseOverview } from "redux/clientProjectSlice";
import { generateYearOptions } from "views/admin/default/components/filterOption";
import { InvoiceNumberFormate } from "jsFunctions/helperFunctions";
import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";
import { pmtNumberFormate } from "jsFunctions/helperFunctions";
import { getSalesInvoiceExcelData } from "components/exportData/excelData/salesInvoiceExcelData";
import { getInvoiceGstExcelData } from "components/exportData/excelData/invoiceRecordExcel";
import { getInvoiceTDSExcelData } from "components/exportData/excelData/invoiceRecordExcel";
import { getInvoicePaymentExcelData } from "components/exportData/excelData/invoiceRecordExcel";
import { allPaymentMode } from "components/allForm/PurchaseItem/selectedOptions";

const {yearOption,defaultSelected} = generateYearOptions();
const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
const formatFilename = filename => `${filename}${moment().format("DD-MMM-YYYY")}`;

const ExpenseDetails = ({ activeTab,projectOptions }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const currUser = useSelector((state) => state.auth.currUser);
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState("");
  const [client, setClient] = useState({});
  const [expenseSummary, setExpenseSummary] = useState({});
  const [selectedYear, setSelectedYear] = useState(defaultSelected);
  const [expenseDetails, setExpenseDetails] = useState({
    allExpenses: [],
    allSales: [],
    salesGst:[],
    salesTds:[],
    salesPayment:[]

  });
  const [projectId,setProjectId] = useState(null);

  useEffect(() => {
    if (currUser && currUser?.auth) {
      const auth = currUser?.auth;
      const roleObj =
        auth &&
        auth?.length > 0 &&
        auth.find((item) => item?.module === "Client Project");
      if (roleObj) {
        setRole(roleObj?.access);
      }
    }
  }, [currUser]);

  const fetchExpenseDetails = async (expenseId) => {
    setLoading(true);
    try {
      const res = await dispatch(
        fetchAsyncGetClientExpenseOverview({
          id: expenseId,
          financialYear: selectedYear,
          projectId
        })
      );
      if (res?.payload) {
        setClient(res?.payload?.client);
        setExpenseDetails({
          allExpenses: res?.payload?.expense?.expenseData || [],
          allSales: res?.payload?.sales?.salesData || [],
          salesGst: res?.payload?.salesGst?.invoiceGst || [],
          salesTds: res?.payload?.salesTds?.invoiceTds || [],
          salesPayment: res?.payload?.salesPayment?.paymentReceived || [],

        });
        const summary = { 
          totalExpense: res?.payload?.expense?.total || 0,
          totalSales: res?.payload?.sales?.total || 0,
          totalTds: res?.payload?.salesTds?.total || 0,
          totalPayment: res?.payload?.salesPayment?.total || 0,
          totalGst: {
            totalGst: res?.payload?.salesGst?.totalGstAmount || 0,
            totalCgst: res?.payload?.salesGst?.totalCgstAmount || 0,
            totalSgst: res?.payload?.salesGst?.totalSgstAmount || 0,
            totalIgst: res?.payload?.salesGst?.totalIgstAmount || 0,
          }


        };
        setExpenseSummary(summary);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching expense details:", error);
    }
  };

  useEffect(() => {
    if (id && activeTab === "expenses") {
      fetchExpenseDetails(id);
    }
  }, [id, selectedYear, activeTab,projectId]);

  const expenseColData = useMemo(() => {
    return expenseDetails.allExpenses.map((data, index) => ({
      _id: data._id,
      no: index + 1,
      poNo: (
        <span style={{ cursor: "pointer", color: "blue" }}>
          {data.poNo && poNumberFormate(data.poNo)}
        </span>
      ),
      purchasedate: dateTimeFormat(data.oDt),
      category: <span>{data?.cat}</span>,
      majorType: <span style={{ cursor: "pointer" }}>{data?.mjId?.val}</span>,
      project: <span style={{ cursor: "pointer" }}>{data?.prId?.prj}</span>,

      minorType: <span style={{ cursor: "pointer" }}>{data?.mnId?.val}</span>,
      sortApdAmt:Number(data.pyInfo?.apAmt || 0),
      approvedAmount: (
        <span style={{ cursor: "pointer" }} className="creditAmount blue">
          {data.pyInfo?.tlAmt ? (
            currencyFormate(data.pyInfo?.apAmt)
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: `<span style="font-family: sans-serif">₹</span> ${Number(
                  0
                ).toFixed(2)}`,
              }}
            />
          )}
        </span>
      ),
    }));
  }, [expenseDetails.allExpenses]);

  const salesColData = useMemo(() => {
    return expenseDetails.allSales.map((data, index) => ({
      _id: data._id,
      no: index + 1,
      inNo: (
        <span style={{ cursor: "pointer", color: "blue" }}>
          {data.inNo && InvoiceNumberFormate(data.inNo)}
        </span>
      ),
      invoiceDate: dateTimeFormat(data.inDt),
      category: <span>{data?.cat}</span>,
      majorType: <span style={{ cursor: "pointer" }}>{data?.mjId?.val}</span>,
      project: <span style={{ cursor: "pointer" }}>{data?.prId?.prj}</span>,

      minorType: <span style={{ cursor: "pointer" }}>{data?.mnId?.val}</span>,
      sortApdAmt:Number(data.pyInfo?.apAmt || 0),
      approvedAmount: (
        <span style={{ cursor: "pointer" }} className="creditAmount blue">
          {data.pyInfo?.tlAmt ? (
            currencyFormate(data.pyInfo?.apAmt)
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: `<span style="font-family: sans-serif">₹</span> ${Number(
                  0
                ).toFixed(2)}`,
              }}
            />
          )}
        </span>
      ),
    }));
  }, [expenseDetails.allSales]);

  const salesGstData = useMemo(()=>{
    const tableData = expenseDetails.salesGst.map((record, index) => {
      const totalGst = (record?.amt?.i ?? 0) + (record?.amt?.s ?? 0) + (record?.amt?.c ?? 0);        
      return {
        _id:record._id,
        no: index + 1,
        inNo: (
          <span 
            style={{ cursor: "pointer",color:'blue'}}
          >
            {record?.inId ? InvoiceNumberFormate(record?.inId?.inNo) : "-"}
          </span>
        ),
        client: <span>{record?.cId?.clName || "-"}</span> ,
        gstNumber: record?.gstNo,
        sortBaseAmt:record?.bsAmt || 0,
        baseAmount:(
          <span>
            {record?.bsAmt ? currencyFormate(record?.bsAmt ): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
          </span>
        ),
        sortIgstAmt:Number(record?.amt?.i || 0),
        igstAmt: (
          <span>
            {record?.amt?.i ? currencyFormate(record?.amt?.i ): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
          </span>
        ),
        sortSgstAmt:Number(record?.amt?.s || 0),
        sgstAmt: (
          <span>
            {record?.amt?.s ? currencyFormate(record?.amt?.s ): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
          </span>
        ),
        sortCgstAmt:Number(record?.amt?.c || 0),
        cgstAmt: (
          <span>
            {record?.amt?.c ? currencyFormate(record?.amt?.c): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
          </span>
        ),
        sortTlAmt:Number(totalGst),
        totalGst: (
          <span className="f-600 green">
            {totalGst ? currencyFormate(totalGst): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
          </span>
        ),
        invoiceDate: dateTimeFormat(record?.inId?.inDt),
      };
    });
    return tableData;
  },[expenseDetails.salesGst])
 
  const salesTdsData = useMemo(()=>{
    const tableData = expenseDetails.salesTds.map((record, index) => {
      return {
        _id:record._id,
        no: index + 1,
        inNo: (
          <span 
            style={{ cursor: "pointer",color:'blue'}}
          >
            {record.inId ? InvoiceNumberFormate(record?.inId?.inNo) : "-"}
          </span>
        ),
        client: <span>{record?.cId?.clName || "-"}</span> ,
        percentage:(<span>{record?.prc || '-'} %</span>),
        sortBaseAmt:record?.bsAmt || 0,
        baseAmount:(
          <span>
            {currencySymbolByCode(record?.inId?.inCr || "INR")} {formatAmountIndianRupees(record?.bsAmt || 0)}
          </span>
        ),
        tdsAmount:(
          <span className="f-600 green">
            {currencySymbolByCode(record?.inId?.inCr || "INR")} {formatAmountIndianRupees(record?.tdsAmt || 0)}
          </span>
        ),
       
        invoiceDate: dateTimeFormat(record?.inId?.inDt),
      };
    });
    return tableData;
  },[expenseDetails.salesTds])

  const salesPaymentData = useMemo(()=>{
    const tableData = expenseDetails.salesPayment.map((record, index) => {
      const payMod = allPaymentMode.find(opt=> opt.id === record?.mod);

      return {
        _id:record._id,
        no: index + 1,
        inNo: (
          <span 
            style={{ cursor: "pointer",color:'blue'}}
          >
            {record.inId ? InvoiceNumberFormate(record?.inId?.inNo) : "-"}
          </span>
        ),
        client: <span>{record?.cId?.clName || "-"}</span> ,
        paymentMode: <Tag bg="green" color="white">{payMod?.value || "-"}</Tag> ,
        paymentId: (
          <span 
            style={{ cursor: "pointer",color:'blue'}}
          >
            {record.pyNo ? pmtNumberFormate(record?.pyNo) : "-"}
          </span>
        ),
        sortBaseAmt:record?.amt || 0,
        amount:(
          <span className="green f-600">
            {currencySymbolByCode(record?.inId?.inCr || "INR")} {formatAmountIndianRupees(record?.amt || 0 )}
          </span>
        ),
        bankCharge:(
          <span>
            {currencySymbolByCode(record?.inId?.inCr || "INR")} {formatAmountIndianRupees(record?.crg || 0 )}
          </span>
        ),
        referanceNo:(<span>{record?.ref || "-"}</span>),
        paymentDate: dateTimeFormat(record?.dt),
      };
    });
    return tableData;
  },[expenseDetails.salesPayment])

  const handleExport = async (data, getExcelData, filenamePrefix) => {
    if (!data || !data.length) {
      addToast(`No data available`, { appearance: "error" });
      return;
    }
    const excelData = await getExcelData(data);
    const ws = XLXS.utils.json_to_sheet(excelData);
    const columnCount = Object.keys(excelData[0]).length;
    const columnWidths = Array(columnCount).fill({ wch: 15 });
    ws["!cols"] = columnWidths;
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLXS.write(wb, { bookType: "xlsx", type: "array" });
    const fileData = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(fileData, formatFilename(`${client?.clName}_${filenamePrefix}_`) + fileExtension);
  };
  const handleExportExpense = () => handleExport(expenseDetails.allExpenses, getVendorExpenseExcelData, "expenses");
  const handleExportInvoice = () => handleExport(expenseDetails.allSales, getSalesInvoiceExcelData, "Sales_Invoice");
  const handleExportInvoiceGst = () => handleExport(expenseDetails.salesGst, getInvoiceGstExcelData, "Invoice_Gst");
  const handleExportInvoiceTds = () => handleExport(expenseDetails.salesTds, getInvoiceTDSExcelData, "Invoice_TDS");
  const handleExportInvoicePayment = () => handleExport(expenseDetails.salesPayment, getInvoicePaymentExcelData, "Payment_Received");
  
  if (loading) {
    return <SpinnerLoader />;
  }

  return (
    <Box display="flex" className="mx-0 expense_details">
      <Box className="expense_details_main">
        <Box display="flex" justifyContent="space-between" alignItems="left">
          <Box display="flex">
          <Text fontWeight="600" fontSize="20px" mt={5}>
            Expense Details
          </Text>
          <Box display="flex" className="mt-3 ">
           
           <Select
             className="mx-3 client-details-select-field"
             width="150px"
             value={selectedYear}
             onChange={(e) => setSelectedYear(e.target.value)}
           >
             {yearOption.map((year) => (
               <option key={year.value} value={year.value}>
                 {year.label}
               </option>
             ))}
           </Select>
           <Select
             className="mx-4 client-details-select-field"
             width="180px"
             value={projectId}
             onChange={(e) => setProjectId(e.target.value)}
           >
            <option value="">Select Project</option>
             {projectOptions.map((prj) => (
               <option key={prj.value} value={prj.value}>
                 {prj.label}
               </option>
             ))}
           </Select>
          
         </Box>
          </Box>
            <Menu>
              <MenuButton
                p="0px"
                className="export_vendor"
                as={Button}
                rightIcon={<FaEllipsisV />}
              ></MenuButton>
              <MenuList className="vendor-menu-list">
                <MenuItem
                  isDisabled={!expenseDetails?.allExpenses?.length}
                  onClick={(e) => handleExportExpense(e)}
                >
                  Export Expense
                </MenuItem>
                <MenuItem
                  isDisabled={!expenseDetails?.allSales?.length}
                  onClick={(e) => handleExportInvoice(e)}
                >
                  Export Invoice
                </MenuItem>
                <MenuItem
                  isDisabled={!expenseDetails?.salesGst?.length}
                  onClick={(e) => handleExportInvoiceGst(e)}
                >
                  Export Invoice GST
                </MenuItem>
                <MenuItem
                  isDisabled={!expenseDetails?.salesTds?.length}
                  onClick={(e) => handleExportInvoiceTds(e)}
                >
                  Export Invoice TDS
                </MenuItem>
                <MenuItem
                  isDisabled={!expenseDetails?.salesPayment?.length}
                  onClick={(e) => handleExportInvoicePayment(e)}
                >
                  Export Payment Received
                </MenuItem>
              </MenuList>
            </Menu>
        </Box>

        <Box className="acordian-box mt-1 ">
          <Accordion defaultIndex={[0]} allowMultiple>
            <AccordionItem className="acordian-item" borderTop="none">
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    <Text fontWeight="600">Expenses </Text>
                  </Box>
                  <Box
                    flex="1"
                    className="mx-3"
                    display="flex"
                    justifyContent="flex-end"
                    flexDirection="row"
                  >
                    <Text className="mt-1" fontWeight="400">
                      Total Expense :{" "}
                      <span className="creditAmount blue">
                        ₹{" "}
                        {expenseSummary?.totalExpense
                          ? formatAmountIndianRupees(
                              expenseSummary?.totalExpense
                            )
                          : Number(0).toFixed(2)}
                      </span>{" "}
                    </Text>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel className="acordian-panal  px-2 p-0 m-0">
                {expenseColData && expenseColData?.length > 0 ? (
                  <ExpenseTable
                    columnsData={expenseDataColumns}
                    tableData={expenseColData}
                    role={role}
                  />
                ) : (
                  <Text className="py-3" fontWeight="600" textAlign="center">
                    There are no Expenses
                  </Text>
                )}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
          <Accordion defaultIndex={[1]} allowMultiple>
            <AccordionItem className="acordian-item" borderTop="none">
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    <Text fontWeight="600">Sales Invoice </Text>
                  </Box>
                  <Box
                    flex="1"
                    className="mx-3"
                    display="flex"
                    justifyContent="flex-end"
                    flexDirection="row"
                  >
                    <Text className="mt-1" fontWeight="400">
                      Total Sales :{" "}
                      <span className="creditAmount blue">
                        ₹{" "}
                        {expenseSummary?.totalSales
                          ? formatAmountIndianRupees(
                              expenseSummary?.totalSales
                            )
                          : Number(0).toFixed(2)}
                      </span>{" "}
                    </Text>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel className="acordian-panal  px-2 p-0 m-0">
                {salesColData && salesColData?.length > 0 ? (
                  <ExpenseTable
                    columnsData={salesDataColumns}
                    tableData={salesColData}
                    role={role}
                  />
                ) : (
                  <Text className="py-3" fontWeight="600" textAlign="center">
                    There are no sales
                  </Text>
                )}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>

          <Accordion defaultIndex={[1]} allowMultiple>
            <AccordionItem className="acordian-item" borderTop="none">
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    <Text fontWeight="600">Invoice GST </Text>
                  </Box>
                  <Box
                    flex="1"
                    className="mx-3"
                    display="flex"
                    justifyContent="flex-end"
                    flexDirection="row"
                  >
                     <Text className="mt-1 mx-3" fontWeight="400">
                      Total IGST :{" "}
                      <span className="creditAmount blue">
                        ₹{" "}
                        {expenseSummary?.totalGst?.totalIgst
                          ? formatAmountIndianRupees(
                              expenseSummary?.totalGst?.totalIgst
                            )
                          : Number(0).toFixed(2)}
                      </span>{" "}
                    </Text>
                    <Text className="mt-1 mx-3" fontWeight="400">
                      Total CGST :{" "}
                      <span className="creditAmount blue">
                        ₹{" "}
                        {expenseSummary?.totalGst?.totalCgst
                          ? formatAmountIndianRupees(
                              expenseSummary?.totalGst?.totalCgst
                            )
                          : Number(0).toFixed(2)}
                      </span>{" "}
                    </Text>
                    <Text className="mt-1 mx-3" fontWeight="400">
                      Total SGST :{" "}
                      <span className="creditAmount blue">
                        ₹{" "}
                        {expenseSummary?.totalGst?.totalSgst
                          ? formatAmountIndianRupees(
                              expenseSummary?.totalGst?.totalSgst
                            )
                          : Number(0).toFixed(2)}
                      </span>{" "}
                    </Text>
                    <Text className="mt-1" fontWeight="400">
                      Total GST :{" "}
                      <span className="creditAmount blue">
                        ₹{" "}
                        {expenseSummary?.totalGst?.totalGst
                          ? formatAmountIndianRupees(
                              expenseSummary?.totalGst?.totalGst
                            )
                          : Number(0).toFixed(2)}
                      </span>{" "}
                    </Text>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel className="acordian-panal  px-2 p-0 m-0">
                {salesGstData && salesGstData?.length > 0 ? (
                  <ExpenseTable
                    columnsData={salesGstRecordColumns}
                    tableData={salesGstData}
                    role={role}
                  />
                ) : (
                  <Text className="py-3" fontWeight="600" textAlign="center">
                    There are no Invoice GST
                  </Text>
                )}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
          <Accordion defaultIndex={[1]} allowMultiple>
            <AccordionItem className="acordian-item" borderTop="none">
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    <Text fontWeight="600">Invoice TDS </Text>
                  </Box>
                  <Box
                    flex="1"
                    className="mx-3"
                    display="flex"
                    justifyContent="flex-end"
                    flexDirection="row"
                  >
                    <Text className="mt-1" fontWeight="400">
                      Total Tds :{" "}
                      <span className="creditAmount blue">
                        ₹{" "}
                        {expenseSummary?.totalTds
                          ? formatAmountIndianRupees(
                              expenseSummary?.totalTds
                            )
                          : Number(0).toFixed(2)}
                      </span>{" "}
                    </Text>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel className="acordian-panal  px-2 p-0 m-0">
                {salesTdsData && salesTdsData?.length > 0 ? (
                  <ExpenseTable
                    columnsData={salesTdsRecordColumns}
                    tableData={salesTdsData}
                    role={role}
                  />
                ) : (
                  <Text className="py-3" fontWeight="600" textAlign="center">
                    There are no Invoice TDS
                  </Text>
                )}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
          <Accordion defaultIndex={[1]} allowMultiple>
            <AccordionItem className="acordian-item" borderTop="none">
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    <Text fontWeight="600">Payment Received</Text>
                  </Box>
                  <Box
                    flex="1"
                    className="mx-3"
                    display="flex"
                    justifyContent="flex-end"
                    flexDirection="row"
                  >
                    <Text className="mt-1" fontWeight="400">
                      Total Payment Received :{" "}
                      <span className="creditAmount blue">
                        ₹{" "}
                        {expenseSummary?.totalPayment
                          ? formatAmountIndianRupees(
                              expenseSummary?.totalPayment
                            )
                          : Number(0).toFixed(2)}
                      </span>{" "}
                    </Text>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel className="acordian-panal  px-2 p-0 m-0">
                {salesPaymentData && salesPaymentData?.length > 0 ? (
                  <ExpenseTable
                    columnsData={salesPaymentRecordColumns}
                    tableData={salesPaymentData}
                    role={role}
                  />
                ) : (
                  <Text className="py-3" fontWeight="600" textAlign="center">
                    There are no payment Received
                  </Text>
                )}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
      </Box>
    </Box>
  );
};

export default ExpenseDetails;
